import { VildVersionStatusType } from 'app/models/enums';

export class VildVersion {
  constructor(
    public id: number,
    public tableNr: string,
    public tableVersion: string,
    public startdate: string,
    public filename: string,
    public status: VildVersionStatusType
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/vildversion.model.ts